<template>
    <form @submit.prevent="submitCode">
        <h4>کد تایید پیامک شده را وارد کنید</h4>
        <Vue3OtpInput
        :num-inputs="6"
        @on-complete="onCodeChange"
        :should-auto-focus="true"
        input-classes="otp-input"
        ref="otpInput"
        separator="-" />
        <button type="submit" style="width: 49%;display: inline-block;margin-left: 1%;">تأیید کد</button>
        <button type="button" @click="editPhone" style="width: 49%;background-color: orangered;display: inline-block;margin-right: 1%;">
            ویرایش شماره
        </button>
        <button
            type="button"
            @click="resendCode"
            :disabled="resendDisabled"
            style="background-color: goldenrod;">
            دریافت پیامک جدید
            <span v-if="resendDisabled">({{ countdown }} ثانیه)</span>
        </button>
    </form>
</template>
<script setup>
    import { ref,onMounted,onUnmounted,defineProps,defineEmits } from 'vue'
    import Vue3OtpInput from "vue3-otp-input"
    import { useUserStore } from '@/stores/user';
    import { useAlertStore } from '@/stores/alert';
    const alertStore = useAlertStore()
    const userStore = useUserStore()
    import router from '@/router'
    const emit = defineEmits(['back'])
    const otpInput = ref(null)
    const code=ref('') 
    const resendDisabled=ref(false)
    const countdown=ref(0)
    const props = defineProps({
        phone: String
    })
    const editPhone = () => {
        sessionStorage.setItem('login_step', '1')
        code.value=''
        emit('back',true)
    }
    function onCodeChange(val) {
        code.value = Array.isArray(val) ? val.join('') : val
        return submitCode();
    }
    const submitCode = async () => {
        if(code.value.length!==6) return
        const response = await userStore.verifySmsCode(props.phone,code.value)
        if (response) {
            if(response.status === 'success'){
                sessionStorage.setItem('login_step', '1')
                sessionStorage.removeItem('submit_phone_timer')
                if (response.url === 'dashboard') {
                    sessionStorage.setItem('isLogin', true);
                    window.dispatchEvent(new Event("storage"));
                    router.push({ name: 'dashboard' })
                } else if (response.url === 'register') {
                    router.push({ name: 'register' })
                } else {
                    alertStore.msg = 'مشخصات ناقص است. لطفاً دوباره تلاش کنید.'
                }
            }else{
                alertStore.msg = 'کد وارد شده اشتباه است.'
            }
        } else {
            alertStore.msg = 'خطا در تأیید کد.'            
        }
    }
    const resendCode = async () => {
        if (resendDisabled.value) return
        const res = await userStore.resendCode(props.phone)
        if (res) {
            alertStore.type=true
            alertStore.msg = 'کد مجدداً ارسال شد.'
            startCountdown()
        } else {
            alertStore.msg = res.message || 'ارسال مجدد موفق نبود'
        }
    }
    let interval = null;
    const startCountdown = () => {
        const now = Date.now()
        const expireTime = now + 60000 
        sessionStorage.setItem('resend_code_timer', expireTime)
        updatecountdown()
        interval = setInterval(updatecountdown, 1000)
    }
    const updatecountdown = () => {
        const expireTime = parseInt(sessionStorage.getItem('resend_code_timer') || 0)
        const now = Date.now()
        const diff = Math.ceil((expireTime - now) / 1000)
        countdown.value = diff > 0 ? diff : 0
        if (countdown.value <= 0 && interval) {
            resendDisabled.value=false
            clearInterval(interval)
            interval = null
        }else{
            resendDisabled.value=true
        }
    }
    onMounted(() => {
        updatecountdown()
        interval = setInterval(updatecountdown, 1000)
        if ("OTPCredential" in window) {
            navigator.credentials.get({ otp: { transport: ["sms"] }, signal: new AbortController().signal })
            .then(otp => { if (otp && otp.code) code.value = otp.code })
            .catch(err => console.warn("WebOTP failed:", err))
        }
    })
    onUnmounted(() => {
        if (interval) clearInterval(interval)
    })
</script>
<style scoped>
    form {
        width: 100%;
    }
    .msg{
        border-radius: 10px;
        background-color: #5e6295;
        color: #fefff8;
        padding: 10px;
        text-align: center;
        margin: 5px auto;
    }
    button {
        display: block;
        width: 100%;
        margin-bottom: 10px;
        background-color: green;
        color: white;
        padding: 9px;
        border-radius: 10px;
        border: none;
        margin-top: 10px;
        margin-bottom: 0;
    }
    button[disabled] {
        opacity: 0.6;
        background-color: rgb(143, 141, 141);
        cursor: not-allowed;
    }
</style>
<style>
    .otp-input-container{ justify-content: space-evenly !important; }
    .otp-input { 
        width: 100%;
        display: block;
        height: 45px;
        text-align: center;
        font-size: 20px;
        border: 1px solid #ccc;
        border-radius: 6px;
    }
</style>